<template>
  <div class="simple-page u-w12of12 u-bg-white-off u-relative">

    <div class="strates">
      <div class="strates__container u-w12of12">
        <div class="hook-text u-pad-y-lg u-pad-y-md--sm u-center">
          <p class="u-pad-x-2of12 t-h3 t-italic u-blue">{{ data.brightStrates[0].titre }}</p>
          <p class="t-text u-pad-x-2of12 u-pad-x-1of12--sm u-inline-block u-marg-t-md u-white-space">{{ data.brightStrates[0].description }}</p>
        </div>

        <!-- 2026-06-17 contact form -->
        <div class="u-pad-x-3of12">
          <div
            class="pipedriveWebForms u-pad-lg u-pad-x-md--sm u-bg-white u-radius"
            data-pd-webforms="https://webforms.pipedrive.com/f/63w0VWecCJmoXpWFPNrlAkvUwYKOh9hdDB0Yxsz0dmrh6Yq2kHrp16KXBgJuArCDjZ"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AppButton from '@/components/common/AppButton'

export default {
  metaInfo () {
    return {
      link: [
        { rel: 'canonical', href: 'https://brig.ht/contact' }
      ]
    }
  },
  components: {
    AppButton
  },

  computed: {
    data () {
      return this.$store.getters['data/page']
    },
    loaded () {
      return this.$store.getters['data/loaded']
    }
  },

  created () {
    this.onInit()
  },

  mounted () {
    this.script = document.createElement('script')
    this.script.src = 'https://webforms.pipedrive.com/f/loader'
    document.body.appendChild(this.script)
  },

  destroyed () {
    if (this.script) {
      document.body.removeChild(this.script)
    }
  },

  methods: {
    onInit () {
      this.$store.dispatch('data/page', 'contact').catch(err => {
        this.$router.push(this.$local('Homepage'))
      })
    }
  },

  watch: {
    $route () {
      this.onInit()
    }
  }
}
</script>

<style>
.pipedriveWebForms {
  margin-bottom: 30px;
}
</style>